export const NATIVE_OAUTH_REDIRECT_URI = 'com.bsmith993.standlogic://auth/callback';
export const NATIVE_OAUTH_SCHEME = 'com.bsmith993.standlogic:';
